import './MapVideoTutorial.less';
import { Checkbox } from 'antd';
import { useState } from 'react';

interface Props {
  visible: boolean;
  videoUrl: string;
  onClose: (dontShow: boolean) => any;
}

function MapVideoTutorial({ visible, videoUrl, onClose }: Props) {

  const [dontShow, setDontShow] = useState(false);

  if (!visible) {
    return null;
  }

  return (
    <div className='tp-task-map-video-tutorial__overlay'
         onClick={() => onClose(dontShow)}
    >
      <div className={'tp-task-map-video-tutorial__video-container'}>
        <video height={'100%'} onClick={e => e.stopPropagation()} controls autoPlay muted>
          <source src={videoUrl} type='video/mp4' />
        </video>
      </div>

      <div onClick={e => e.stopPropagation()}
           className='tp-task-map-video-tutorial__button-container'>
        <Checkbox
          checked={dontShow}
          onChange={() => setDontShow(!dontShow)}
        >
          No volver a mostrar.
        </Checkbox>
      </div>
    </div>
  );
}

export default MapVideoTutorial;
